export default __webpack_public_path__ + "locales/bg/FormFillingTipsDialog.json?hash=fa8b02abf325f6cf3310153353ab30eb";